import { combineReducers } from "redux";

import latestStories from "./latestStories";
import navigation from "./navigation";
import newsletters from "../subscriptions/reducers/newsletters";
import storiesStream from "./storiesStream";
import subscriptions from "../subscriptions/reducers/subscriptions";

export default combineReducers({
  latestStories,
  navigation,
  newsletters,
  storiesStream,
  subscriptions,
});
